import type { CSSProperties, JSX, ReactNode } from 'react';

import { FB_KINDS, statusOf, type FeedbackKind } from '../../lib/feedback';
import { IconBug, IconCircleHelp, IconLightbulb } from './feedback-icons';

/** Значок вида обращения (ошибка / идея / вопрос) в цвете вида. */
export function KindIcon({ kind, size = 15 }: { kind: FeedbackKind; size?: number }): JSX.Element {
  const Icon = kind === 'bug' ? IconBug : kind === 'idea' ? IconLightbulb : IconCircleHelp;
  return (
    <span className="fk-hub-fb-kind" style={{ '--fb-tone': (FB_KINDS[kind] ?? FB_KINDS.question).tone } as CSSProperties}>
      <Icon size={size} />
    </span>
  );
}

/** Плашка-пилюля. tone — CSS-цвет (токен), подложка считается от него. */
export function Pill({ tone, children, dot, title }: { tone: string; children: ReactNode; dot?: boolean; title?: string }): JSX.Element {
  return (
    <span className="fk-hub-fb-pill" style={{ '--fb-tone': tone } as CSSProperties} title={title}>
      {dot ? <span className="fk-hub-fb-pill-dot" /> : null}
      {children}
    </span>
  );
}

export function StatusPill({ status, label }: { status: string; label?: string }): JSX.Element {
  return (
    <Pill tone={statusOf(status).tone} dot>
      {label ?? statusOf(status).label}
    </Pill>
  );
}
